var file_upload_viewer_default = {
  "fontElementMap": "JJlBM",
  "file_upload_container": "UOumR",
  "file_upload_error_container": "l-o9C",
  "file_upload_link": "LGTl3",
  "width_three": "vHMIh",
  "file_upload_text_container": "r8DJV",
  "width_two": "Z9nOF",
  "file_upload_state": "WE1IY",
  "mobile_status_icon": "pBtTO",
  "file_upload_name_container": "oV-WC",
  "file_upload_name": "kJ9Id",
  "file_upload_extension": "ne1bd",
  "width_one": "gbXOA",
  "file_upload_type_icon": "sxYy9",
  "file_loader_icon": "Dvy1l",
  "spin": "-fDSy",
  "file_upload_type": "udlYQ",
  "file_upload_text_error": "GLNlZ",
  "file_upload_icon_frame": "_8D5-V",
  "file_upload_icon_background": "qUVd9"
};
export {
  file_upload_viewer_default as default
};
//# sourceMappingURL=file-upload-viewer-scss.js.map
